document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('monogramModal');
    const overlay = document.getElementById('monogramOverlay');
    const closeBtn = document.getElementById('monogramCloseBtn');
    const triggerBtn = document.getElementById('mgModalTrigger');
    const stepNavs = document.querySelectorAll('.step-nav');
    const steps = document.querySelectorAll('.monogram-step');
    const monogramInput = document.getElementById('monogramText');
    const originalMinLength = monogramInput.getAttribute('minlength');
    const originalMaxLength = monogramInput.getAttribute('maxlength');
    const instructionGeneric = modal.querySelector('.field__instruction:not(.field__instruction--cube)');
    const instructionCube = modal.querySelector('.field__instruction--cube');
    const costPerLetter = parseFloat(document.getElementById('monogramCostPerLetter')?.value || 0);
    const monogramTotalCost = document.getElementById('monogramTotalCost');
    const summaryPanel = document.getElementById('monogramSummary');
    const editBtn = document.getElementById('monogramEditBtn');
    const removeBtn = document.getElementById('monogramRemoveBtn');
    const agreeCheckbox = document.getElementById('monogramAgree');

    if (!modal || !overlay || !steps.length || !stepNavs.length) return;

    let currentStep = 1;
    let maxStepReached = 1; // Tracks how far the user has progressed
    const selected = {
        colour: '',
        location: '',
        style: '',
        text: '',
        price: '',
    };

    const resetMonogramModal = () => {
        currentStep = 1;
        maxStepReached = 1;
        showStep(currentStep);

        // Clear all selected state
        selected.style = '';
        selected.text = '';
        selected.colour = '';
        selected.location = '';
        selected.price = 0;

        // Reset the step nav classes
        document.querySelectorAll('.step-nav').forEach(stepNavItem => {
            stepNavItem.classList.remove('active');
            stepNavItem.classList.remove('available');
        });

        // Unselect any selected buttons
        document.querySelectorAll('.option-thumbnails button.selected').forEach(btn => {
            btn.classList.remove('selected');
        });

        // Reset text input
        if (monogramInput) {
            monogramInput.value = '';
            monogramInput.setAttribute('minlength', originalMinLength);
            monogramInput.setAttribute('maxlength', originalMaxLength);
        }

        // Reset instructions
        if (instructionGeneric) instructionGeneric.style.display = '';
        if (instructionCube) instructionCube.style.display = 'none';

        // Disable all "Next" buttons initially
        document.querySelectorAll('.monogram-next').forEach(btn => {
            btn.disabled = true;
        });

        // Reset confirmation button
        if (confirmBtn) {
            confirmBtn.disabled = true;
            document.getElementById('monogramTotalCost').textContent = 'x';
        }

        // Uncheck confirmation checkbox
        if (agreeCheckbox) {
            agreeCheckbox.checked = false;
        }
    }

    if (editBtn) {
        editBtn.addEventListener('click', () => {
            openModal();
        })
    }

    if (removeBtn) {
        removeBtn.addEventListener('click', () => {
            if (summaryPanel) summaryPanel.hidden = true;
            if (triggerBtn) triggerBtn.hidden = false;

            // Clear hidden inputs
            ['mgStyle', 'mgText', 'mgColour', 'mgLocation', 'mgPrice'].forEach(id => {
                const el = document.getElementById(id);
                if (el) el.value = '';
            });

            // Clear `selected object
            Object.keys(selected).forEach(key => {
                selected[key] = '';
            });

            // Reset modal
            resetMonogramModal();
        })
    }

    const updateMonogramCost = () => {
        const letterCount = monogramInput.value.trim().length;
        const totalCost = letterCount * costPerLetter;

        // Format as £X.XX
        monogramTotalCost.textContent = totalCost.toFixed(2);
    };

    const showStep = (step) => {
        steps.forEach(s => s.hidden = s.dataset.step !== String(step));
        stepNavs.forEach(n => {
            const stepNum = Number(n.dataset.step);
            n.classList.toggle('active', stepNum === step);
            n.classList.toggle('available', stepNum <= maxStepReached);
        });
    };

    stepNavs.forEach(nav => {
        nav.addEventListener('click', () => {
            const step = Number(nav.dataset.step);
            if (step <= maxStepReached) {
                currentStep = step;
                showStep(currentStep);
            }
        });
    });

    const advanceStep = () => {
        // Checks for min length letters, as it can change depending on the style
        if (currentStep === 2) {
            const value = monogramInput.value.trim();
            const min = parseInt(monogramInput.getAttribute('minlength'), 10);
            const max = parseInt(monogramInput.getAttribute('maxlength'), 10);

            if (value.length < min || value.length > max) {
                if (min === max) {
                    alert(`Please enter ${min} letters.`);
                } else {
                    alert(`Please enter between ${min} and ${max} letters.`);
                }
                return; // prevent advancing
            }

            selected.text = value;
        }

        if (currentStep < 4) {
            currentStep++;
            maxStepReached = Math.max(maxStepReached, currentStep);
            showStep(currentStep);
        }
    };

    document.querySelectorAll('.monogram-next').forEach(btn => {
        btn.addEventListener('click', advanceStep);
    });

    // Thumbnail selections
    document.querySelectorAll('.option-thumbnails').forEach(group => {
        const field = group.dataset.input;
        if (!field) return;

        const buttons = group.querySelectorAll('button');
        const nextBtn = group.closest('.monogram-step')?.querySelector('.monogram-next');
        if (!nextBtn) return;

        buttons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const btn = e.target.closest('button');
                if (!btn || !group.contains(btn)) return;

                const newValue = btn.dataset.value;

                // Only reset input + update limits if this is the style step and style actually changed
                if (field === 'style' && selected.style !== newValue) {
                    selected.style = newValue;

                    const newMin = btn.dataset.minLetters;
                    const newMax = btn.dataset.maxLetters;

                    monogramInput.setAttribute('minlength', newMin || originalMinLength);
                    monogramInput.setAttribute('maxlength', newMax || originalMaxLength);
                    monogramInput.value = '';

                    // Update instruction visibility
                    const isCube = newValue === 'Cube';
                    instructionGeneric.style.display = isCube ? 'none' : '';
                    instructionCube.style.display = isCube ? '' : 'none';
                }

                selected[field] = btn.dataset.value;

                group.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
                btn.classList.add('selected');

                nextBtn.disabled = false;
            });
        });
    });

    // Text input step
    const textInput = document.getElementById('monogramText');
    if (textInput) {
        const costPerLetter = parseFloat(document.getElementById('monogramCostPerLetter')?.value || 0);
        const monogramTotalCost = document.getElementById('monogramTotalCost');

        const updateMonogramCost = () => {
            const letterCount = textInput.value.trim().length;
            const total = letterCount * costPerLetter;
            if (monogramTotalCost) {
                monogramTotalCost.textContent = total.toFixed(2);
            }

            // Store numeric total in selected object
            selected.price = total;
        };

        textInput.addEventListener('input', () => {
            const value = textInput.value.trim();
            const min = parseInt(textInput.getAttribute('minlength'), 10);
            const max = parseInt(textInput.getAttribute('maxlength'), 10);
            const nextBtn = textInput.closest('.monogram-step')?.querySelector('.monogram-next');

            if (nextBtn) {
                nextBtn.disabled = value.length < min || value.length > max;
            }

            selected.text = value;
            updateMonogramCost();
        });
    }

    // Final step: agreement + location
    const confirmBtn = document.getElementById('confirmMonogramBtn');
    const currentProductId = document.getElementById('currentProductId');
    const monogramVariantId = document.getElementById('monogramVariantId');
    const locationGroup = document.querySelector('[data-input="location"]');

    const validateFinal = () => {
        if (confirmBtn && selected.location && agreeCheckbox?.checked) {
            confirmBtn.disabled = false;
        } else if (confirmBtn) {
            confirmBtn.disabled = true;
        }
    };

    if (locationGroup) {
        locationGroup.addEventListener('click', (e) => {
            const btn = e.target.closest('button');
            if (!btn || !locationGroup.contains(btn)) return;

            locationGroup.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
            btn.classList.add('selected');

            selected.location = btn.dataset.value;
            validateFinal();
        });
    }

    if (agreeCheckbox) {
        agreeCheckbox.addEventListener('change', validateFinal);
    }

    if (confirmBtn) {
        confirmBtn.addEventListener('click', async () => {
            closeModal();

            // console.log('Selected monogram:', selected);

            // Only continue if everything is present
            if (!selected.style || !selected.text || !selected.colour || !selected.location) return;

            // Show summary panel
            if (triggerBtn) triggerBtn.hidden = true;
            if (summaryPanel) summaryPanel.hidden = false;

            // Update price in summary
            const priceEl = document.getElementById('monogramSummaryPrice');
            if (priceEl) priceEl.textContent = selected.price.toFixed(2);

            // List the selected options
            const list = document.getElementById('monogramSummaryList');
            if (list) {
                list.innerHTML = `
                    <li>Style: ${selected.style}</li>
                    <li>Text: ${selected.text}</li>
                    <li>Colour: ${selected.colour}</li>
                    <li>Location: ${selected.location}</li>
                `;
            }

            // Update hidden fields for line properties
            const updateHidden = (id, value) => {
                const input = document.getElementById(id);
                if (input) input.value = value;
            }

            updateHidden('mgStyle', selected.style);
            updateHidden('mgText', selected.text);
            updateHidden('mgColour', selected.colour);
            updateHidden('mgLocation', selected.location);
            updateHidden('mgPrice', `£${selected.price.toFixed(2)}`);
        });
    }

    const productForm = document.querySelector('.product__form');
    const addToCartButtons = productForm ? productForm.querySelectorAll('button[type="submit"][name="add"]') : null;

    // Now add the monogram product to the cart
    addToCartButtons.forEach(addToCartBtn => {
        addToCartBtn.addEventListener('click', async (evt) => {
            evt.preventDefault();

            const formData = new FormData(productForm);

            // Step 1: Add main product
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                console.error(response);
                return;
            }

            // Step 2: Add monogram fee product
            if (selected.text && selected.text.length) {
                const quantity = selected.text.length;

                await fetch('/cart/add', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: monogramVariantId.value,
                        quantity: quantity,
                        properties: {
                            'Linked to': formData.get('id'),
                            'Type': 'Monogram Fee'
                        }
                    })
                });
            }

            // Disable the Add to Cart button so user isn't confused and understands they need to wait a second
            addToCartBtn.classList.add('disabled');
            addToCartBtn.disabled = true;

            // Redirect to cart page
            window.location.href = '/cart';
        });
    });

    const openModal = () => {
        modal.classList.add('show');
        overlay.classList.add('show');
        currentStep = 1;
        showStep(currentStep);
    };

    const closeModal = () => {
        modal.classList.remove('show');
        overlay.classList.remove('show');
    };

    closeBtn?.addEventListener('click', closeModal);
    overlay?.addEventListener('click', closeModal);
    triggerBtn?.addEventListener('click', openModal);
});